import settings from '@/settings'
import i18n from '@/i18n'
import Vue from 'vue'
import store from './store/'

export default {
	sanitize (value) {
		var rst = value;
		if (!rst || !isFinite(rst) || isNaN(rst) || rst.length == 0) rst = 0;
		return rst;
	},
	format(v, u) {
		var rst = v;
		var unit = settings.data.units.find(e => e.name === u);
		if (unit) {
			rst = rst.toFixed(unit.decimals);
		}

		return rst;
	},
	loadSettings() {
		Vue.storage.getItem('settings').then((data) => {
			if (data) {
				try {
					settings.data = JSON.parse(data);
					i18n.locale = settings.data.language;
					return;
				} catch(e) {
					Vue.storage.removeItem('settings');
				}
			}
			var localeLanguage = 'en-US';
			if (window.Intl && typeof window.Intl === 'object') {
				localeLanguage = navigator.language;
			}
			settings.data.language = localeLanguage;
			settings.data.defaultYarnCount = 'nm';
			settings.data.defaultYarnType = 'ribbon-yarn';
			this.saveSettings();
		});
	},
	saveSettings() {
		var parsed = JSON.stringify(settings.data);
		Vue.storage.setItem('settings', parsed);
		i18n.locale = settings.data.language;
	},
	autoLogin(token) {
		return new Promise((resolve, reject) => {
			if (token) {
				store.commit('authSuccess', {token: token});
				store.dispatch('customerRequest')
				.then(() => {
					resolve();
				})
				.catch((err) => {
					// store.dispatch('authError', {err: err});
					reject(err);
				});
			} else {
				resolve();
			}
		});
	}
}

export const yarnCountUtils = {
	units: [
		{name: 'denier-name', short: 'DEN', code: 'den', description: 'denier-description'},
		{name: 'decitex-name', short: 'DTEX', code: 'dtex', description: 'decitex-description'},
		{name: 'tex-name', short: '', code: 'tex', description: 'tex-description'},
		{name: 'metric-name', short: 'NM', code: 'nm', description: 'metric-description'},
		{name: 'english-cotton-name', short: 'NE', code: 'ne', description: 'english-cotton-description'},
		{name: 'woollen-name', short: 'YSM', code: 'ysm', description: 'woollen-description'},
		{name: 'worsted-name', short: '', code: 'worsted', description: 'worsted-description'},
		{name: 'dewsbury-name', short: '', code: 'dewsbury', description: 'dewsbury-description'},
		{name: 'linen-name', short: 'WETSPUN', code: 'wetspun', description: 'linen-description'},
		{name: 'jute-name', short: '', code: 'jute', description: 'jute-description'}
	],
	select(n) {
		return this.units.find(e => e.code === n);
	},
	convert(n, from, to) {
		var nm = this.convertToNm(from, n);
		return this.convertFromNm(to, nm);
	},
	convertToNm(unit, n) {
		var rst = 0;

		if (isNaN(n)) n = 0;

		n = parseFloat(n);


		switch (unit) {
			case 'den':
				rst = 9000 / n;
				break;	
			case 'dtex':
				rst = 10000 / n;
				break;	
			case 'tex':
				rst = 1000 / n;
				break;	
			case 'nm':
				rst = n * 1;
				break;	
			case 'ne':
				rst = n * 1.693361817351556;
				break;	
			case 'ysm':
				rst = n * 0.5160721729071421;
				break;	
			case 'worsted':
				rst = n * 1.1289078782343722;
				break;	
			case 'dewsbury':
				rst = n * 0.032254510806696404;
				break;	
			case 'wetspun':
				rst = n * 0.6047720776255561;
				break;	
			case 'jute':
				rst = n * 290.2905972602671;
				break;
		}
		if (!isFinite(rst) || isNaN(rst)) rst = 0;
		return rst;
	},
	convertFromNm(unit, n) {
		var rst = 0;

		if (isNaN(n)) n = 0;
		n = parseFloat(n);

		switch (unit) {
			case 'den':
				rst = 9000 / n;
				break;	
			case 'dtex':
				rst = 10000 / n;
				break;	
			case 'tex':
				rst = 1000 / n;
				break;	
			case 'nm':
				rst = n * 1;
				break;	
			case 'ne':
				rst = n / 1.693361817351556;
				break;	
			case 'ysm':
				rst = n / 0.5160721729071421;
				break;	
			case 'worsted':
				rst = n / 1.1289078782343722;
				break;	
			case 'dewsbury':
				rst = n / 0.032254510806696404;
				break;	
			case 'wetspun':
				rst = n / 0.6047720776255561;
				break;	
			case 'jute':
				rst = n / 290.2905972602671;
				break;	
		}

		if (!isFinite(rst) || isNaN(rst)) rst = 0;
		return rst;
	}
}

export const yarnUtils = {
	types: [
		{name: 'fancy-yarn', code: 'fancy-yarn'},
		{name: 'ribbon-yarn', code: 'ribbon-yarn'},
		{name: 'soft-knit-yarn', code: 'soft-knit-yarn'}
	],
	selectType(c) {
		return this.types.find(e => e.code === c);
	}
}